import React, { useEffect, useState } from 'react';

import { Stack } from '@mui/material';

import { ColumnsCount } from '../../../../../../documents/blocks/ColumnsContainer/ColumnsContainerLayout';

import TextDimensionInput from './TextDimensionInput';

export const DEFAULT_2_COLUMNS = [6] as [number];
export const DEFAULT_3_COLUMNS = [4, 8] as [number, number];
export const DEFAULT_4_COLUMNS = [3, 3, 3, 3] as [number, number, number, number];

type TWidthValue = number | null | undefined;
type FixedWidths = [
  TWidthValue,
  TWidthValue,
  TWidthValue,
  TWidthValue,
];
type ColumnsLayoutInputProps = {
  columnsCount: ColumnsCount;
  defaultValue: FixedWidths | null | undefined;
  onChange: (v: FixedWidths | null | undefined) => void;
};

export default function ColumnWidthsInput({
  columnsCount,
  defaultValue,
  onChange,
}: ColumnsLayoutInputProps) {
  const [currentValue, setCurrentValue] = useState<FixedWidths>(() => {
    if (defaultValue) {
      return defaultValue;
    }
    return [null, null, null, null];
  });

  useEffect(() => {
    if (defaultValue) {
      setCurrentValue(defaultValue);
    }
  }, [defaultValue]);

  const setIndexValue = (index: 0 | 1 | 2 | 3, value: number | null | undefined) => {
    const nValue: FixedWidths = [...currentValue];
    nValue[index] = value;
    setCurrentValue(nValue);
    onChange(nValue);
  };

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {Array.from({ length: columnsCount }, (_, index) => (
        <TextDimensionInput
          key={index}
          label={`Column ${index + 1}`}
          defaultValue={currentValue[index]}
          onChange={(v) => {
            setIndexValue(index as 0 | 1 | 2 | 3, v);
          }}
        />
      ))}
    </Stack>
  );
}
